module.exports = __webpack_public_path__ + "static/media/logo179.7b8f31b8.png";